import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Spinner() {
  return (
    <Box sx={{ display: 'flex' , justifyContent : "center", mx:2}}>
      <CircularProgress size="20px" />
    </Box>
  );
}
